const urls = [
    'https://api64.ipify.org?format=json',
    'https://ip-api.io/json',
    'https://ipapi.co/json',
    'https://ipv4.my.ipinfo.app/api/ipDetails.php',
    'https://myip.ipip.net/json'
]
/**
 * 判断IP地址类型
 * @param {string} ip - 要检查的IP地址
 * @returns {'IPv4' | 'IPv6'} IP地址类型
 */
function getIpType(ip) {
    // IPv4正则表达式
    const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/;
    // IPv6正则表达式
    const ipv6Regex = /^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$|^([0-9a-fA-F]{1,4}:){1,7}:|^([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}$|^([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}$|^([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}$|^([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}$|^([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}$|^[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})$|^:((:[0-9a-fA-F]{1,4}){1,7}|:)$/;

    if (ipv4Regex.test(ip)) {
        return 'IPv4';
    } else if (ipv6Regex.test(ip)) {
        return 'IPv6';
    }
    throw new Error('无效的IP地址格式');
}

/**
 * 轮流调用IP查询接口，直到成功获取IP地址
 * @returns {Promise<string>} 返回IP地址
 * @throws {Error} 当所有接口都失败时抛出错误
 */
async function getIp() {
    console.log('getIp')
    for (const url of urls) {
        try {
            const response = await fetch(url);
            const data = await response.json();
            if (!data.ip || getIpType(data.ip) !== 'IPv4') {
                continue;
            }
            
            // 根据不同接口的返回格式提取IP
            if (data.ip) {
                return data.ip;
            }else if(data.data.ip){
                return data.data.ip
            }
        } catch (error) {
            console.error(`Failed to fetch IP from ${url}:`, error);
            continue;
        }
    }
    throw new Error('所有IP查询接口都失败了');
}

export {getIp};
